/* src/app/hire-person-search/hire-suggestions-list/hire-suggestions-list.component.scss */
.suggestions-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.suggestion-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 0px 0;
  border-radius: 4px;
  transition: opacity 0.15s ease;
}
.suggestion-item:hover {
  opacity: 0.75;
}
.suggestion-plus {
  font-size: 12px;
  font-weight: 600;
  color: #e91e8c;
  line-height: 1;
}
.suggestion-text {
  font-size: 14px;
  font-weight: 400;
  color: #484b59;
  line-height: 1;
  white-space: nowrap;
}
.ai-suggestion {
  background:
    linear-gradient(
      267deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
}
/*# sourceMappingURL=hire-suggestions-list.component-BSGG22RB.css.map */
